import * as React from 'react';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';
import DropdownCtrl from '@webapp/controllers/form/dropdown';
import { Option } from '@webapp/types/common/option';
import { Country } from '@common/types/data/country';
import { ContactInfo } from '@webapp/types/common/contact-info';

interface EmailOrPhoneCtrlProps {
  className?: string;
  value?: string;
  error?: React.ReactNode;
  country: Country;
  decoration?: React.ReactElement;
  type?: 'email' | 'telephone';
  propagateClick?: boolean;
  hasClose?: boolean;
  countries: Country[];
  countriesOptions: Option[];
  onClose?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  onChange?: (value: ContactInfo) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  onCountryChange?: (value: Country) => void;
}

const mapStateToProps = (state: AppState) => ({
  countries: state.categories.countries,
  countriesOptions: state.categories.countries.map((c) => ({
    value: c.id,
    label: `${c.name} (+${c.code})`,
  })),
});

const checkCountry = (newValue: string, c: Country) => {
  const result = newValue.startsWith(`+${c.code}`);
  if (result && c.areaCodes) {
    const areaCode = c.areaCodes.find((a) =>
      newValue.startsWith(`+${c.code}${a}`)
    );
    if (!areaCode) {
      return false;
    }
  }
  return result;
};

const updateCountry = (
  newValue: string,
  country: Country,
  countries: Country[],
  onChange?: (value: Country) => void
) => {
  const newCountry = countries.find((c) => checkCountry(newValue, c));
  if (newCountry && newCountry.id !== country.id) {
    if (onChange) {
      onChange(newCountry);
    }
  }
};

export const CountriesCntrl: React.FC<EmailOrPhoneCtrlProps> = (props) => {
  const propsValue = props.value || '';
  const { countries, onCountryChange } = props;

  const [value, setValue] = React.useState(propsValue);
  const [filter, setFilter] = React.useState('');
  const [loaded, setLoaded] = React.useState(false);
  const [flagPage, setFlagPage] = React.useState(1);

  React.useEffect(() => {
    if (!loaded && !value && propsValue && countries.length) {
      if (!checkCountry(propsValue, props.country)) {
        updateCountry(propsValue, props.country, countries, onCountryChange);
      }

      setValue(propsValue);
      setLoaded(true);
    }
  }, [loaded, propsValue, value, props.country, countries, onCountryChange]);

  const handleCountryChange = (id: string) => {
    const newCountry = props.countries.find((c) => c.id === id);

    if (newCountry && props.onCountryChange) {
      props.onCountryChange(newCountry);
    }
  };

  return (
    <DropdownCtrl
      className={props.className}
      title="Country"
      value={props.country.id}
      onChange={(countryId) => handleCountryChange(countryId)}
      hasFilter
      filterLabel="Find your country"
      customFilterValue={filter}
      onCustomFilter={setFilter}
      getNextPage={(step) => setFlagPage(flagPage + step)}
      options={props.countries.map((country) => ({
        value: country.id,
        label: country.name,
      }))}
    />
  );
};

export default connect(mapStateToProps)(CountriesCntrl);
